import React, { useEffect, useState } from "react";
import { listTranslations, saveTranslation } from "@/lib/api";
import { PageHeader } from "@/pages/admin/AdminDashboard";
import { toast } from "sonner";
import { Save, Plus } from "lucide-react";

const SEED_KEYS = [
  "nav.home", "nav.books", "nav.research_themes", "nav.about", "nav.join", "nav.contact",
  "cta.join_mission", "cta.explore_books", "cta.watch_intro",
  "hero.headline", "hero.tagline",
  "footer.publisher", "footer.copyright",
];

export default function AdminTranslations() {
  const [rows, setRows] = useState([]);
  const [newKey, setNewKey] = useState("");

  const load = () => listTranslations().then(list => {
    const map = new Map(list.map(r => [r.key, r]));
    const merged = SEED_KEYS.map(k => map.get(k) || { key: k, en: "", hi: "", bn: "", status: "draft" });
    // include any db-only keys
    list.forEach(r => { if (!SEED_KEYS.includes(r.key)) merged.push(r); });
    setRows(merged);
  });

  useEffect(() => { load(); }, []);

  const setAt = (i, patch) => setRows(rs => rs.map((r, j) => j === i ? { ...r, ...patch } : r));
  const saveRow = async (r) => { try { await saveTranslation(r.key, r); toast.success("Saved"); } catch { toast.error("Failed"); } };
  const addKey = () => { if (!newKey.trim()) return; setRows(rs => [...rs, { key: newKey.trim(), en: "", hi: "", bn: "", status: "draft" }]); setNewKey(""); };

  return (
    <div data-testid="admin-translations-page">
      <PageHeader eyebrow="Localisation" title="UI Translations" note="Enter approved translations only. Automatic translation is not used for published content." />
      <div className="mt-8 flex items-center gap-3">
        <input className="gi-input" placeholder="new.key.name" value={newKey} onChange={e => setNewKey(e.target.value)} data-testid="translations-new-key" />
        <button onClick={addKey} className="btn-outline" data-testid="translations-add-key"><Plus size={12} /> Add key</button>
      </div>
      <div className="mt-6 border bg-white" style={{ borderColor: "var(--gi-border)" }} data-testid="translations-table">
        <div className="grid grid-cols-[220px_1fr_1fr_1fr_120px_100px] gap-3 px-4 py-3 border-b text-[10px] font-accent" style={{ borderColor: "var(--gi-border)", color: "var(--gi-muted)", letterSpacing: "0.14em" }}>
          <div>Key</div><div>English</div><div>हिन्दी</div><div>বাংলা</div><div>Status</div><div></div>
        </div>
        {rows.map((r, i) => (
          <div key={r.key} className="grid grid-cols-[220px_1fr_1fr_1fr_120px_100px] gap-3 px-4 py-3 border-b last:border-b-0 items-start" style={{ borderColor: "var(--gi-divider)" }} data-testid={`translations-row-${r.key}`}>
            <div className="text-xs font-mono" style={{ color: "var(--gi-charcoal-2)" }}>{r.key}</div>
            <textarea rows={2} className="gi-input" value={r.en || ""} onChange={e => setAt(i, { en: e.target.value })} data-testid={`translations-en-${r.key}`} />
            <textarea rows={2} className="gi-input" value={r.hi || ""} onChange={e => setAt(i, { hi: e.target.value })} data-testid={`translations-hi-${r.key}`} />
            <textarea rows={2} className="gi-input" value={r.bn || ""} onChange={e => setAt(i, { bn: e.target.value })} data-testid={`translations-bn-${r.key}`} />
            <select className="gi-input" value={r.status || "draft"} onChange={e => setAt(i, { status: e.target.value })} data-testid={`translations-status-${r.key}`}>
              <option value="draft">Draft</option>
              <option value="under_review">Under Review</option>
              <option value="published">Published</option>
            </select>
            <button onClick={() => saveRow(rows[i])} className="btn-ghost" data-testid={`translations-save-${r.key}`}><Save size={12} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
